<template>
  <div>
    <my-head></my-head>
    <div class="trusteeship minH">
      <div class="crumbs">
        首页 > 运营服务 >
        <span style="color: #1d2129">IP托管</span>
      </div>

      <div class="title">IP托管</div>

      <div class="content">
        知识产权托管是基于知识产权的法律界定性和长期持有、非货币性、创造经济效益不稳定的无形资产特性，提出的一种新的服务模式。企业根据管理需求与托管服务商，在签订严格保守企业商业秘密的授权托管协议下，托管服务商在授权范围内，代为管理知识产权相关的业务，包括咨询、申请取得、知识产权使用、知识产权转让与许可、知识产权战略、知识产权评估及质押融资使用、知识产权变现、知识产权侵权保护和维权等。<br />
        企业可将知识产权相关事务委托给知识产权服务机构进行管理，通俗的讲，就是企业给自己找一个管家。企业根据管理需求，与服务机构签订授权托管协议，托管服务机构代为管理知识产权相关业务，包括申请取得、使用、转让与许可、质押融资、侵权保护和维权等。这样，企业可以更全面地管理和使用自已的无形资产。
      </div>

      <img src="../../assets/trusteeship_1.png" class="trusteeship_img" />
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
export default {
  components: { MyHead, MyFooter },
};
</script>

<style lang="scss">
.trusteeship {
  width: 80%;
  margin: 24px auto 60px;
  .trusteeship_img {
    width: 100%;
    margin-bottom: 130px;
  }
  .content {
    font-size: 14px;
    margin-bottom: 32px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
  }
  .title {
    font-size: 30px;
    margin-bottom: 32px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
  }
}
</style>
